var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":function($event){return _vm.print()}}},[_vm._v("Print test ticket")]),_c('iframe',{staticStyle:{"display":"none"},attrs:{"id":"ticket"}})])}
var staticRenderFns = []

export { render, staticRenderFns }